package com.islamicmedia.shared.util

actual val isDebugBuild: Boolean = false
actual val appVersion: String = "3.4.0"
actual val appBuildNumber: String = "web"
actual val platformName: String = "Web"
